<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <!--<el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>-->
            <el-breadcrumb-item>销售概览</el-breadcrumb-item>
        </el-breadcrumb>

        <table border="1">
            <tr>
                <td>
                    <el-select v-model="kioskNo" placeholder="机器编号" @change="kioskNoStatus()">
                        <el-option label="全部售货机" value="">全部售货机</el-option>
                        <el-option
                                v-for="(item,index) in kioskList"
                                :label="item.deviceName"
                                :value="item.deviceId"
                        >
                        </el-option>
                    </el-select>
                    <!--<el-select class="m-1" v-model="kioskNo" placeholder="机器编号" style="margin: 10px;"-->
                               <!--@change="kioskNoStatus()">-->
                        <!--<el-option label="所有设备" value="">所有设备</el-option>-->
                        <!--<el-option label="K1-A112" value="K1-A112" v-show="this.getcookie('storeId')=='store001'">-->
                            <!--K1-A112-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                </td>
            </tr>
            <tr style="background-color: #eeeeee">
                <div style="font-weight:bold;margin: 10px 10px 10px 30px;">今日实时</div>
            </tr>
            <tr>
                <el-button style="margin: 5px; width: 30%;height: 70px; font-size: 25px"> {{orderCount}}
                    <br/>
                    <span style="font-size: 10px;">销售数量</span>
                </el-button>
                <el-button style="margin: 5px; width: 30%;height: 70px; font-size: 25px">
                    {{"￥"+orderPrice}}<br/><span style="font-size: 10px;">销售金额</span>
                </el-button>
                <el-button style="margin: 5px; width: 30%;height: 70px; font-size: 25px">
                    {{"￥"+guestPrice}}<br/><span style="font-size: 10px;">客单价</span>
                </el-button>
            </tr>
            <tr style="background-color: #eeeeee">
                <span style="margin-left: 30px;font-weight:bold;">
                        筛选日期：
                    <el-date-picker
                            style="width: auto;"
                            class="m-1"
                            v-model="datatime"
                            type="daterange"
                            align="right"
                            :clearable=false
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                    <el-button type="primary" style="margin-left: 30px;" @click="drawLine()">筛选</el-button>
                    <span style="margin-left: 50px;">
                        快速查看：<el-button @click="timeFind(6)">近7天</el-button> <el-button
                            @click="timeFind(29)">近30天</el-button>
                    </span>
                </span>
            </tr>
            <tr>
                <!-- 操作-->
                <div style="height:400px;">
                    <div id="myChart" style="height:300px;margin-top:40px;" height="400"></div>
                </div>
            </tr>
            <tr style="background-color: #eeeeee;text-align: center">
                <div style="font-weight:bold;margin: 10px 10px 10px 30px;" v-show="kioskNoFlag">售货机排行榜</div>
            </tr>
            <tr>
                <el-table :data="tableDatakiosk" border style="width: 70%;margin-left: 10%;"
                          v-show="kioskNoFlag">
                    <el-table-column type="index" width="50" label="排名"></el-table-column>
                    <el-table-column prop="kioskNo" label="售货机ID"></el-table-column>
                    <el-table-column prop="kioskName" label="售货机名称"></el-table-column>
                    <el-table-column prop="sumPrice" label="付款金额"></el-table-column>
                </el-table>
            </tr>
            <tr style="background-color: #eeeeee;text-align: center">
                <div style="font-weight:bold;margin: 10px 10px 10px 30px;" v-show="productFlag">商品排行榜</div>
            </tr>
            <tr>
                <el-table :data="tableDatapro" border style="width: 70%;margin-left: 10%;" v-show="productFlag">
                    <el-table-column type="index" width="50" label="排名"></el-table-column>
                    <el-table-column prop="productName" label="商品名称"></el-table-column>
                    <el-table-column prop="price" label="单价"></el-table-column>
                    <el-table-column prop="counSKU" label="付款数量"></el-table-column>
                </el-table>
            </tr>
        </table>


    </div>


</template>
<script>
    import moment from 'moment'
    import ElButton from "../../../../node_modules/element-ui/packages/button/src/button.vue";

    export default {

        components: {ElButton},
        data() {
            return {
                tableDatapro: [],
                tableDatakiosk: [],
                /*弹窗选择*/
                //参数设置
                url: this.productURL + "/vueFeign/statisticalOrder", // 分页查询请求路径
                prourl: this.productURL + "/vueFeign/statisticalProduct", // 分页查询请求路径
                /*弹窗内容选择*/
                name: '',
                kioskNo: '',
                kioskList:[],
                orderCount: '0',
                orderPrice: '0',
                guestPrice: '0',
                datatime: [new Date(new Date(new Date().toLocaleDateString()).getTime() - 6 * 24 * 60 * 60 * 1000), new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)],
                loading: false,
                isorno: false,
                rows: 0,
                kioskNoFlag: true,
                productFlag: false,

            }

        },
        mounted() {
            this.drawLine();
        },
        created() {
            this.kioskLists();
            this.kioskNoStatus();
        },
        methods: {
            kioskLists(){
                //数据请求
                var params = {orgIds:'6P86B3U8',tenantId:this.getcookie('storeId'),Token:'12345'};
                //异步请求
                this.$http.get(this.productURL+"/vueFeign/findDeviceList",{
                    params: params})
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.kioskList = response.body.Data;
                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                        this.getData();
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            kioskNoStatus() {
                if (this.kioskNo == '') {
                    this.kioskObj();
                    this.kioskNoFlag = true;
                    this.productFlag = false;
                } else {
                    this.productObj();
                    this.kioskNoFlag = false;
                    this.productFlag = true;
                }
                this.getData();
                this.drawLine();
            },
            getData() {
                var nowDate = new Date(new Date().toLocaleDateString());//获取当前时间
                var params = {
                    startTime: nowDate.getTime(), endTime: new Date().getTime()
                    , tenantId: this.getcookie('storeId'), kioskNo: this.kioskNo
                };
                //异步请求
                this.$http.get(this.url, {params: params})
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == '500') {
                                this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                            } else {
                                this.orderCount = response.body.Data.orderlist[0].count;
                                this.orderPrice = response.body.Data.orderlist[0].orderTotal;
                                this.guestPrice = response.body.Data.orderlist[0].guestPrice;
                            }
                        }
                    });
            },
            timeFind(row) {
                this.datatime.splice(0, 1, new Date(new Date(new Date().toLocaleDateString()).getTime() - row * 24 * 60 * 60 * 1000));
                this.datatime.splice(1, 1, new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1));
                this.drawLine();
            },
            drawLine() {
                //算出日期天数
                this.timeFn();
                if (this.rows > 30) {
                    this.$message({showClose: true, message: "最多查看三十天之内数据", type: 'error'});
                } else {
                    // 基于准备好的dom，初始化echarts实例
                    let myChart = this.$echarts.init(document.getElementById('myChart'));
                    // 绘制图表
                    myChart.setOption({
                        title: {text: '销售情况'},
                        legend: {
                            data: [
                                {
                                    name: '订单销量'
                                }, {
                                    name: '订单总额'
                                }, {
                                    name: '客单价'
                                }
                            ]
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                            }
                        },
                        toolbox: {
                            show: true,
                            orient: 'vertical',
                            x: '40px',
                            y: 'center',
                            feature: {
                                mark: {show: true},
                                dataView: {show: false, readOnly: false},
                                magicType: {show: true, type: ['line', 'bar']},
                                restore: {show: true},
                                saveAsImage: {show: true}
                            }
                        },
                        calculable: true,
                        xAxis: {
                            type: 'category',
                            data: []
                        },
                        yAxis: [{
                            type: 'value',
                            name: '订单总额',
                            axisLabel: {
                                formatter: '￥{value}'
                            }
                        },
                            {
                                type: 'value',
                                name: '订单销量',
                                axisLabel: {
                                    formatter: '{value} 次'
                                }
                            }],
                        series: []
                    });

//                var nowDate = new Date(new Date().toLocaleDateString());//获取当前时间
                    var params = {
                        startTime: this.datatime[0].getTime(), endTime: this.datatime[1].getTime()
                        , tenantId: this.getcookie('storeId'), kioskNo: this.kioskNo
                    };
                    //异步请求
                    this.$http.get(this.url, {params: params})
                        .then(response => {
                            if (response.status === 200) {
                                if (response.body.Code == '500') {
                                    this.$message({showClose: true, message: response.body.Meta, type: 'error'});
                                } else {
                                    var order1 = [];
                                    var order2 = [];
                                    var order3 = [];
                                    var order4 = [];
                                    var dateTime = this.datatime[1].getTime();
                                    for (var i = 0; i < this.rows; i++) {
                                        order1.push(0);
                                        order2.push(0);
                                        order4.push(0);
                                        order3.push(this.formatter(dateTime));
                                        dateTime = dateTime - 1 * 24 * 60 * 60 * 1000;
                                    }
                                    for (var i = 0; i < this.rows; i++) {
                                        for (var j = 0; j < response.body.Data.orderlist.length; j++) {
                                            if (order3[i] == response.body.Data.orderlist[j].dateTime) {
                                                console.log(response.body.Data.orderlist[j].count)
                                                order1.splice(i, 1, response.body.Data.orderlist[j].count);
                                                order2.splice(i, 1, response.body.Data.orderlist[j].orderTotal);
                                                order4.splice(i, 1, response.body.Data.orderlist[j].guestPrice);
                                            }
                                        }
                                    }
                                    console.log(order3);
                                    myChart.setOption({
                                        xAxis: {
                                            data: order3
                                        },
                                        series: [{
                                            name: '订单销量',
                                            type: 'line',
                                            yAxisIndex: 1,
                                            data: order1
                                        }, {
                                            name: '订单总额',
                                            type: 'bar',
                                            yAxisIndex: 0,
                                            data: order2
                                        }, {
                                            name: '客单价',
                                            type: 'bar',
                                            data: order4
                                        }
                                        ]
                                    })
                                }
                            }
                        }, function (response) {
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        })

                }
            },
            timeFn() {//di作为一个变量传进来
                var dateDiff = this.datatime[1].getTime() - this.datatime[0].getTime();//时间差的毫秒数
                this.rows = Math.floor(dateDiff / (24 * 3600 * 1000)) + 1;//计算出相差天数
                console.log(this.rows);
            },
            kioskObj() {
                this.$http.get(this.productURL + "/vueFeign/statistical/kiosk", {params: {"tenantId": this.getcookie('storeId')}}).then(response => {
                    if (response.status === 200) {
                        if (response.body.Code === "200") {
                            this.tableDatakiosk = response.body.Data.orderlist;
                            var array = response.body.Data.orderlist;
                            for (let i = 0; i < array.length; i++) {
                                var newSumPrice = "￥"+array[i].sumPrice
                                this.tableDatakiosk[i].sumPrice=newSumPrice;
                            }

                        } else {
                            this.$message({showClose: true, message: "统计售货机效率失败", type: 'error'});
                        }
                    }
                }, function (response) {
                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'

                    });
                })
            },
            productObj() {
                this.$http.get(this.prourl, {
                    params: {
                        "tenantId": this.getcookie('storeId'),
                        "kioskNo": this.kioskNo
                    }
                }).then(response => {
                    if (response.status === 200) {
                        if (response.body.Code === "200") {
                            this.tableDatapro = response.body.Data.orderlist;
                            //price
                            var array = response.body.Data.orderlist;
                            for (let i = 0; i < array.length; i++) {
                                var newPrice = "￥"+array[i].price
                                this.tableDatapro[i].price=newPrice;
                            }
                        } else {
                            this.$message({showClose: true, message: "统计售货机效率失败", type: 'error'});
                        }
                    }
                }, function (response) {
                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'

                    });
                })
            },
            fileSpan() {
                this.isorno = false;
            },
            formatter(row) {
                console.log()
                var d = new Date(row)
                var formatString = formatString || 'MM-DD';
                return moment(d).format(formatString);
            },
            yformatter(row) {
                console.log()
                var d = new Date(row)
                var formatString = formatString || 'YYYY-MM-DD';
                return moment(d).format(formatString);
            },

            /**--------------------------------------end--------------------------------------------------------**/

        }

    }

</script>
<style>
    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }

    .customWidth {
        width: 60%;
    }

    .box_relative {
        float: left;
    }
</style>



// WEBPACK FOOTER //
// appletSaleCount.vue?d72c2370